import React, {useState, useEffect} from 'react';
import {Container, Col, Row, Button} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import HeadLineComponent from './HeadLineComponent';
import PaymentProcessBackComponent from './PaymentProcessBackComponent';
import RadioInput from '../../Shared/RadioInput/RadioInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import images from './images/images';
import {gaReportShownPage} from './gaReports';
import radioBtnOnIcon from './images/radio-btn/radio-btn-on.svg';


const NewPaymentMethodComponent = ({props, setNewSelectedPaymentMethod, resetDeptPaymentFlag}) => {
  if (props.data.currentStep !== 4) {
    return null;
  }

  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    gaReportShownPage('select_new_payment_method');
    setTimeout(() => {
      props.setProgressBarPercent(60);
    }, props.data.animationTimeOut);

    //reset deptPayment flag
    if (props.data.renderFromDeptPayment) {
      resetDeptPaymentFlag();
    }
  }, []);

  const onRadioBtnChange = (e) => {
    let value = e.currentTarget.value;
    props.saveNewSelectedPaymentMethod(value);
    props.saveToHistory();
  };

  const backToSelectCustomersStep = () => {
    setAnimateOut(true);
    setTimeout(() => {
      props.handleCurrentStep(3);
    }, props.data.animationTimeOut);
  };

  const continueUpdate = () => {
    setAnimateOut(true);
    setTimeout(() => {
      props.handleCurrentStep(5);
    }, props.data.animationTimeOut);
  };

  return (
    <div className={`${animateOut ? 'animateOut' : 'animateIn'}`}>
      <HeadLineComponent text={'עדכון אמצעי תשלום'} />
      <Container>
        {!props.data.isDeptPayment && (
          <PaymentProcessBackComponent
            selectedPaymentMethods={props.data.selectedPaymentMethods}
            selectedInvoices={props.data.selectedInvoices}
            buttonFunction={backToSelectCustomersStep}
          />
        )}
        <Row>
          <Col className={`p-0`}>
            <div className='background-container select-new-payment-method'>
              <p className='bold text-right mb-0'>בחרו את אמצעי התשלום החדש:</p>

              {props.data.paymentMethodsRadioBtns.map((btn) => {
                let image = btn.label == props.data.paymentMethods.CREDIT_CARD ? images.creditcard : images.bank;

                return (
                  <div className='radio-btn-item' key={btn.id}>
                    <RadioInput
                      checked={props.data.newSelectedPaymentMethod == btn.value}
                      id={btn.id}
                      name='payment'
                      value={btn.value}
                      label={btn.label}
                      image={image}
                      checkedIcon={radioBtnOnIcon}
                      onChange={onRadioBtnChange}
                    />
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12} className={`btn-337 btn-row pr-0 pl-0 text-center`}>
            <BtnSubmit isBusiness={props.data.isBusinessBlock} text='המשך' onclick={() => continueUpdate()} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewPaymentMethodComponent;
